import React from 'react';
import { Icon, IconComponent } from './icon';
import src from 'grpn-mx-mixer/dist/images/icons/gear.svg';

export const IconGear: IconComponent = props => <Icon {...props} src={src} />;
